"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./components/TeachingPopoverBody/index"), exports);
